export default {
    差价合约:'ETF CFDs',
    把握全球:'100가지 인기 있는 글로벌 ETF CFD 거래 가능하며, 주식, 채권, 주제별, 레버리지 ETF가 포함되어 있습니다. 펀드 계좌가 필요 없으며, 양방향 거래가 가능하고 레버리지를 지원합니다.',
    即刻开户:'계좌 개설하기',
    优势:'주요 특징',
    差价合约是一种:'ETF 차액결제거래(CFD)는 글로벌 주요 ETF에 레버리지를 적용해 양방향 거래가 가능한 유연한 금융 상품으로, 시장의 가격 변동을 포착하고 포트폴리오를 다변화하려는 투자자에게 적합합니다.',
    品种丰富:'다양한 상품 구성',
    支持100:'전 세계 인기 ETF CFD 100종 거래 지원',
    灵活交易:'유연한 거래 전략',
    支持买入:'매수·매도 모두 지원, 상승·하락 기회 포착 가능',
    无需持有:'자산 보유 없이 거래 가능',
    无需持有资产:'자산을 실제로 보유하지 않고도 글로벌 ETF 가격 변동에 손쉽게 투자할 수 있습니다.',
    杠杆交易:'레버리지 거래 가능',
    杠杆配置:'최대 5:1 레버리지로 자금 운용 효율 극대화',
    开设模拟账户:'데모계좌 개설하기',
    开设真实账户:'실계좌 개설하기',
    如何开始交易:'거래 시작 방법',
    注册账号:'계정 등록',
    注册并登录:'계정을 등록하고 사용자 센터에 로그인하여 신원 인증을 완료하세요.',
    下载MT5交易平台:'MT5 거래 플랫폼을 다운로드하세요.',
    开通真实交易账号:'MetaTrader 5에서 실거래 계정을 개설하세요.',
    开始交易:'거래를 시작하세요.',
    选择ETF:'ETF CFD 상품을 선택하세요.',
    即刻交易:'지금 바로 거래를 시작하세요.',
    差价合约相关问题:'ETF CFD 관련 질문',
    有什么区别:'1. ETF CFD와 전통적인 ETF는 어떤 차이가 있나요?',
    是差价合约交易:'ETF CFD는 실물 자산의 인도 없이 가격 차이를 거래하는 방식으로, 증권 계좌 개설이나 ETF 보유가 필요 없습니다. 단기, 양방향, 레버리지 전략에 더 적합한 거래 방식입니다.',
    购买ETF才能交易:'"2.실제로 ETF를 구매해야 거래할 수 있나요?"',
    通过EBC提供的ETF:'필요하지 않습니다. EBC에서 제공하는 ETF CFD 상품을 통해 ETF를 보유하지 않고도 가격 변동에 따라 거래할 수 있으며, 모든 거래는 플랫폼 내에서 간편하게 진행됩니다.',
    交易会收取哪些费:'"	3.ETF CFD 거래에는 어떤 수수료가 발생하나요?"',
    您无需支付传统ETF的管理费:'전통적인 ETF의 운용 수수료나 중개 수수료는 발생하지 않습니다. 거래 비용은 주로 매수·매도 스프레드와 오버나이트 포지션에 대한 이자 비용이며, 구체적인 비용은 플랫폼에서 실시간으로 확인하실 수 있습니다.',
    可以做空吗:'4.ETF CFD는 공매도가 가능한가요?',
    与传统ETF只能做多不:'가능합니다. 전통적인 ETF가 매수만 가능한 것과 달리, ETF CFD는 공매도를 지원하여 변동성이 크거나 하락장에서도 전략적으로 대응할 수 있습니다.',
    适合新手交易者:'5.ETF CFD는 초보자에게 적합한가요?',
    CFD产品具有杠杆属性:'CFD 상품은 레버리지 특성이 있어 일정 수준의 리스크 인식과 거래 경험이 있는 사용자에게 적합합니다. 초보자라면 실거래에 앞서 모의 계좌를 통해 상품 구조를 충분히 익힌 후 거래를 시작하는 것을 권장합니다.',
    市场报价:'시장 시세',
    查看所有产品:'전체 상품 보기',
}